import script from "./NavBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavBar.vue?vue&type=script&lang=ts&setup=true"

import "./NavBar.vue?vue&type=style&index=0&id=5f92f089&lang=scss&scoped=true"

import exportComponent from "/Users/mac/work/aem/weixin-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f92f089"]])

export default __exports__